import dynamic from "next/dynamic";

import {
  SHOP_CORE_SORT_OPTIONS,
  SortDirection,
} from "@/api/requests/consumerApi/searchShopCoreMenuItems";

const Dropdown = dynamic(() => import("@/components/botanic/Dropdown"), {
  ssr: true,
});

export type SortState = {
  sort: SHOP_CORE_SORT_OPTIONS;
  sortDirection: SortDirection;
};

/* eslint-disable sort-keys-fix/sort-keys-fix -- order matters */
const shopCoreLabels = (
  isDeliveryFulfillmentMode: boolean,
): { [key: string]: SortState | null } => ({
  Recommended: null,
  ...(isDeliveryFulfillmentMode
    ? {
        "Delivery fee": {
          sort: SHOP_CORE_SORT_OPTIONS.DELIVERY_FEE,
          sortDirection: "asc",
        },
        "Delivery minimum": {
          sort: SHOP_CORE_SORT_OPTIONS.DELIVERY_MINIMUM,
          sortDirection: "asc",
        },
        "Delivery time": {
          //this
          sort: SHOP_CORE_SORT_OPTIONS.DELIVERY_TIME,
          sortDirection: "asc",
        },
      }
    : {
        Distance: {
          sort: SHOP_CORE_SORT_OPTIONS.PICKUP_DISTANCE,
          sortDirection: "asc",
        },
      }),
  "THC: low to high": {
    sort: SHOP_CORE_SORT_OPTIONS.THC,
    sortDirection: "asc",
  },
  "THC: high to low": {
    sort: SHOP_CORE_SORT_OPTIONS.THC,
    sortDirection: "desc",
  },
  "Price: low to high": {
    sort: SHOP_CORE_SORT_OPTIONS.PRICE,
    sortDirection: "asc",
  },
  "Price: high to low": {
    sort: SHOP_CORE_SORT_OPTIONS.PRICE,
    sortDirection: "desc",
  },
});
/* eslint-enable sort-keys-fix/sort-keys-fix */

const ShopCoreSort = ({
  isDeliveryFulfillmentMode = true,
  onChange,
  selectedSort,
}: {
  isDeliveryFulfillmentMode?: boolean;
  onChange: (newVal: SortState | null) => void;
  selectedSort: SortState | null;
}) => {
  const SHOP_CORE_SORT_LABEL_MAP = shopCoreLabels(isDeliveryFulfillmentMode);

  const getLabelForSortState = (sortState: SortState | null): string => {
    if (!sortState) {
      return "Recommended";
    }

    const sortConfig = Object.entries(SHOP_CORE_SORT_LABEL_MAP).find(
      ([_label, labelSortState]) =>
        labelSortState?.sort === sortState.sort &&
        labelSortState?.sortDirection === sortState.sortDirection,
    );

    return sortConfig ? sortConfig[0] : "";
  };
  return (
    <div
      data-testid="sort-dropdown"
      className="flex flex-shrink-0 items-center justify-center ml-lg"
    >
      <Dropdown
        variant="small"
        label="Sort by"
        className="items-center"
        preselectedOption={getLabelForSortState(selectedSort)}
        options={Object.keys(SHOP_CORE_SORT_LABEL_MAP)}
        onItemRender={(option) => ({
          children: option,
          onClick: () => {
            const sortState = SHOP_CORE_SORT_LABEL_MAP[option];
            if (sortState !== undefined) {
              onChange(sortState);
            }
          },
        })}
      />
    </div>
  );
};

export default ShopCoreSort;
